import { twSort } from '../../utils';

export const h5 = twSort`font-serif text-base leading-tight font-normal`;
export const captionMedium = twSort`font-sans text-sm leading-tight font-normal tracking-[0.16px]`;

export const textStyles = {
  h1: twSort`font-sans text-2xl leading-tight font-semibold`,
  h2: twSort`font-sans text-xl leading-tight font-semibold`,
  h3: twSort`font-serif text-xl leading-tight font-normal tracking-wide`,
  h4: twSort`block font-sans text-2xl leading-snug font-semibold tracking-normal text-inherit antialiased`,
  h5: twSort`block font-sans text-xl leading-snug font-semibold tracking-normal text-inherit antialiased`,
  h6: twSort`block font-sans text-base leading-relaxed font-semibold tracking-normal text-inherit antialiased`,
  small: twSort`block font-sans text-sm leading-normal font-light text-inherit antialiased`,
  p: twSort`text-accent font-sans text-xs leading-normal font-normal`,
  div: twSort`text-accent font-sans text-xs leading-normal font-normal`,
  tooltip: twSort`font-sans text-[0.625rem] leading-tight font-normal tracking-[0.16px]`,
};
